// extracted by mini-css-extract-plugin
export var contactLink = "styles-module--contactLink--1fb10";
export var contributionShareText = "styles-module--contributionShareText--025ac";
export var hideSm = "styles-module--hideSm--86d14";
export var iconWrapper = "styles-module--iconWrapper--c9ee4";
export var label = "styles-module--label--e8640";
export var link = "styles-module--link--cc0f9";
export var noMargins = "styles-module--noMargins--8718e";
export var verticallyAligned = "styles-module--verticallyAligned--f6122";